module.exports = {
  "country": "PT",
  "artist": "Salvador Sobral",
  "song": "Amar Pleos Dois",
  "year": "2017",
  "place": "1",
  "spotify": "68HpTFETy6D25IR3G0gKtG"
};